import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Modal, FormControl, InputGroup } from 'react-bootstrap';
import { settingvalidate, affvalidate, validliquiditytoken } from '../../hooks/kycvalidation';
import { updateaffhook } from '../../hooks/usebackend';
import { API_URL } from '../../config/env'
import proof from "../../images/proof.webp"

class Editsettingmodal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            afflicatesettingModal: true,
            minAffiliate:'',
            maxAffiliate:'', 
            errors: {}

        };
    }

    componentDidMount() {
        console.log("affid",this.props.data)
        if (!this.state.minAffiliate && !this.state.maxAffiliate) {
            this.setState({ "minAffiliate": this.props.data.minAffiliate });
            this.setState({ "maxAffiliate": this.props.data.maxAffiliate })
        }
    }
    handleedit = async () => {
        let payload = {
            minAffiliate: this?.state?.minAffiliate,
            maxAffiliate: this?.state?.maxAffiliate
        }
        let validate = await affvalidate(payload);
        console.log(validate, "cmsvalidate")
        if (validate?.isValid) {
            let data = {
                id: this.props.data?._id,
                minAffiliate: this?.state?.minAffiliate,
                maxAffiliate: this?.state?.maxAffiliate
            }
            let result = await updateaffhook(data);
            console.log("result", result)
            this.props.onDismiss();
            this.props.get()
        }
        else {
            this.setState({ "errors": validate.errors })
        }
    }

 

    render() {


        const { afflicatesettingModal } = this.state


        return (



            <Modal className="wallet-modal" show={afflicatesettingModal} centered size="md">
                <Modal.Header className='pt-3 header_odal_head'>
                    <h3 className="sec-head ">Edit Affiliate</h3>
                    <button type="button" class="close" onClick={() => this.props.onDismiss()}><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>

                </Modal.Header>
                <Modal.Body className="select-wallet modal_body pt-0 pb-0 px-0">

                    <div className="wallet-lists px-2">

                        <div className='mod_pad_space pt-0'>
                            <div className='row'>
                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <div className='mb-3'>
                                        <p className='input_desc_sm'>Affiliate minimum percentage :</p>
                                        <div class="inputs input-groups"><div class="input-group"><input  id="mininput" class="form-control" value={this.state.minAffiliate}  
                                        onChange={(e)=>{this.setState({"minAffiliate" : e?.target?.value}) }}/></div></div>
                                          <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.minAffiliate}</span>
                                    </div>
                                    <div>
                                        <p className='input_desc_sm'>Affiliate maximum percentage :</p>
                                        <div class="inputs input-groups"><div class="input-group"><input  id="mininput" class="form-control" value={this.state.maxAffiliate}
                                        onChange={(e)=>{this.setState({"maxAffiliate" : e?.target?.value}) }}/></div></div>
                                          <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.maxAffiliate}</span>
                                    </div>
                                </div>
                                {/* <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Setting Name</p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="settingname" placeholder="Setting Name"
                                                aria-describedby="basic-addon2"
                                                value={this.state.settingname}
                                                onChange={(e) => {
                                                    this.setState({ "settingname": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.settingvalue}</span>
                                    </div>
                                </div>

                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Setting Value</p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="hardcap" value={this?.state?.settingvalue} placeholder="Setting Value"
                                                aria-describedby="basic-addon2"
                                                onChange={(e) => {
                                                    this.setState({ "settingvalue": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.settingvalue}</span>
                                    </div>
                                </div> */}

{/* 
                                <div className="row mb-3 px-3">
                                    <div className='col-8 col-sm-8 col-md-8 px-1 mb-3'>
                                        <p className='input_desc_sm'>Afflicate Min Input:</p>


                                    </div>

                                </div> */}


                                <div className='col-12 col-md-12 px-1 text-center'>
                                    <button className="get-started-btn mt-2" onClick={this.handleedit}>
                                        Submit
                                    </button>

                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>



        )
    }

}


export default Editsettingmodal